module.exports = __webpack_public_path__ + "static/media/pointing-up.bd86ef51.png";